import Cookies from 'js-cookie'

export const getToken = () => {
  return Cookies.get('admin_token')
}

export const setToken = (token) => {
  Cookies.set('admin_token', token)
}

export const removeToken = () => {
  Cookies.remove('admin_token')
}
